import React, { useState, useRef, useEffect } from "react";
import { IonApp, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonMenu, IonMenuToggle, IonPage, IonRadio, IonRadioGroup, IonTitle, IonToolbar } from '@ionic/react';
import topics from "../../menus/UKG/EnvironmentScience";
import { Helmet } from "react-helmet";

const EnvironmentScience: React.FC = () => {

    const handleSubmit = (url: string) => {
        window.location.href = url;
    }

    useEffect(() => {
        document.title = "Mamas Guidance - UKG - Environment Science"; // Set page title
    }, []);

    return (
        <>
            <Helmet>
                <meta name="description" content='Discover engaging UKG Environmental Science activities on Mama’s Guidance. Explore topics like animals, plants, seasons, and daily surroundings through interactive and fun learning resources.' />
            </Helmet>
            <div className={`my-topic-container`}>
            {topics.map((slide, index) => (
                <IonItem key={index} routerLink={slide.url}
                    routerDirection="none"
                    lines="none"
                    detail={true}>
                    <IonLabel>{slide.title}</IonLabel>
                </IonItem>
            ))}
        </div>
        </>
    );
};
export default EnvironmentScience;